import React from 'react';
import { useLocation, NavLink } from 'react-router-dom'; // Make sure this is imported
import { BiHomeSmile, BiCompass, BiUser, BiBell, BiInfoCircle, BiFileBlank, BiFile, BiDockTop, BiChevronLeft, BiLink } from "react-icons/bi";
import Logo from '../assets/Image/whiteLogo.png'

export const Navlinks = [
  {
    path: "/dashboard",
    icon: <BiHomeSmile />,
    name: "Dashboard",
  },
  {
    path: "/explore",
    icon: <BiCompass />,
    name: "Explore",
  },
  {
    path: "/users",
    icon: <BiUser />,
    name: "Users",
  },
  {
    path: "/links",
    icon: <BiLink />,
    name: "Links",
  },
  {
    path: "/notification",
    icon: <BiBell />,
    name: "Notifications",
  },
  {
    path: "/aboutus",
    icon: <BiInfoCircle />,
    name: "About Us",
  },
  {
    path: "/privacy",
    icon: <BiFileBlank />,
    name: "Privacy Policy",
  },
  {
    path: "/terms&conditions",
    icon: <BiFile />,
    name: "Terms & Conditions",
  },
  {
    path: "/account",
    icon: <BiDockTop />,
    name: "Account",
  },
];

const Sidebar = ({ isMenuOpen, toggleMenu }) => {
  const location = useLocation(); // ✅ Move this inside the component
  return (
    <aside
      id="layout-menu"
      className={`layout-menu menu-vertical menu bg-menu-theme ${isMenuOpen ? 'menu-open' : ''}`}
      style={isMenuOpen ? { transform: 'translate3d(0, 0, 0)', transition: 'transform 0.3s ease' } : { transform: 'translate3d(-100%, 0, 0)', transition: 'transform 0.3s ease' }} >
      <div className="app-brand demo justify-content-center mb-4">
        <img src={Logo} alt="" height={90} />

        <button onClick={toggleMenu} className="layout-menu-toggle menu-link text-large ms-auto d-xl-none">
          <BiChevronLeft className={`bx-sm d-flex align-items-center justify-content-center ${isMenuOpen ? 'rotate-0' : ''}`} />
        </button>
      </div>

      <div className="menu-inner-shadow"></div>

      <ul className="menu-inner py-1 ps">
        {Navlinks.map((link, index) => (
          <li className="menu-item" key={index}>
            <NavLink
              to={link.path}
              className={`nav-link d-flex align-items-center menu-link ${location.pathname.startsWith(link.path) && (link.path === '/explore' || location.pathname === '/explore/add') ? 'active' : ''
                }`}
            >
              <i className="menu-icon">{link.icon}</i>
              <div className="text-truncate">{link.name}</div>
            </NavLink>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;
